import styled from 'styled-components';

export const Container = styled.main`
  align-items: center;
  background-color: white;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 2rem;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`;

export const ErrorContainer = styled.section`
  background-color: #2c2c2c;
  padding: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

export const ErrorMessage = styled.article`
  color: #ffcc00;
  font-size: 1.2rem;
`;

export const ErrorStack = styled.article`
  color: #ff6666; 
  font-size: 1rem;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ff6666;
  padding: 10px;
  border-radius: 5px;
  background-color: #1a1a1a;
`;
